import { useIntl } from 'react-intl';
import { LocationsRadiusFilterOptions } from 'types/FilterOptions';
import { Select, SelectOption, InputNumber } from 'ui';
import { FormInstance } from 'antd';
import { StyledLocationRadiusSelector } from './style';

interface Props {
  locations: LocationsRadiusFilterOptions[] | undefined;
  isLoading?: boolean;
  form: FormInstance<any>;
}

export const LocationRadiusSelector = ({ locations, form }: Props) => {
  const intl = useIntl();
  const value = form.getFieldValue('location_radius');

  return (
    <StyledLocationRadiusSelector>
      <div className={'form-title'}>
        {intl.formatMessage({ id: 'form.location_title' })}
      </div>
      <Select
        placeholder={intl.formatMessage({ id: 'form.select_location_placeholder' })}
        className={`drop-down ${!!value && 'selected'}`}
        showSearch={true}
        name={'location_radius'}
        size={'small'}
        allowClear
      >
        {locations?.map((location, index) => (
          <SelectOption key={`${index}-loc`} value={location.name}>
            {location.name}
          </SelectOption>
        ))}
      </Select>

      {value && (
        <InputNumber
          placeholder={intl.formatMessage({ id: 'form.select_radius_placeholder' })}
          controls={true}
          name={'distance_radius'}
          type={'number'}
          className={'location-distance-radius-input'}
        />
      )}
    </StyledLocationRadiusSelector>
  );
};
